exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{-webkit-appearance:none}#app{font-family:microsoft yahei,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-size:3.73333vmin;color:#4d4d4d;height:100%}body,html{overflow-y:auto;overflow-x:hidden;overscroll-behavior:none;-webkit-overscroll-behavior:none}.cube-picker-cancel,.cube-picker-confirm{font-size:4vmin!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d7fe165","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = Ozp/
// module chunks = 76